import type { InsuranceCarrier } from "@/core/types";
import { EXCLUDED_SECONDARY_CARRIERS } from "../constants";

export interface CarrierOption {
  label: string;
  value: InsuranceCarrier;
}

export const filterSecondaryCarrierOptions = (carrierOptions: CarrierOption[]): CarrierOption[] => {
  return carrierOptions.filter((option) => !EXCLUDED_SECONDARY_CARRIERS.includes(option.value));
};
